import React, { useState, useEffect, useCallback } from 'react'

import './main.css'
import 'react-toastify/dist/ReactToastify.css'

import { Outlet, useNavigate } from 'react-router-dom'

import Header from '../header/header'
import Menu from '../menu/menu'
import Footer from '../footer/footer'
import Logo from '../../assets/SBF-Logo-1.png'

import useAuth from '../../hooks/useAuthContext'
import useApp from '../../hooks/useAppContext'
import useNotificacoesPolling from '../../hooks/useNotificacoesPolling'

import { useLocation } from 'react-router-dom'

const Main = () => {
  const navigate = useNavigate()
  const { validarUser, isAppLoaded, setIsAppLoaded, usuario } = useAuth()
  const { consultarNotificacoes, verificaPesquisa } = useApp()
  const location = useLocation()

  useNotificacoesPolling({
    enabled: Boolean(usuario?.tipo && usuario.tipo !== 'recepcao'),
    consultarNotificacoes,
  })

  useEffect(() => {
    verificaPesquisa()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario?.tipo])

  const fetchProfile = async () => {
    try {
      let validacao = await validarUser()
      if (validacao?.acessoBloqueado) {
        navigate('/acesso-em-breve')
        return
      }
      if (validacao?.tipo === 'recepcao') {
        navigate('/private/adm/recepcao')
      }
      setIsAppLoaded(true)
    } catch (error) { }
  }

  useEffect(() => {
    fetchProfile()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getAppTemplate = useCallback(() => {
    if (!isAppLoaded) {
      return (
        <div className="loading">
          <img
            src={Logo}
            alt="SBF"
            width={'50%'}
          />
        </div>
      )
    }
    return (
      <div className="wrapper">
        <Header />
        <Menu />
        <Outlet />
        {location.pathname.includes('/private/adm') || location.pathname.includes('private/chat/') ? false : <Footer />}
      </div>
    )
  }, [isAppLoaded, location])

  return getAppTemplate()
}

export default Main
